import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-2"
}
const _hoisted_3 = {
  key: 2,
  class: "mt-8 flex justify-center mb-24"
}

import { ref, watch, onMounted, onUnmounted } from "vue";
import DiamondsSearchResultDiamond from "./result/diamondsSearchResultDiamond.vue";
import DiamondsSearchResultLoading from "./result/diamondsSearchResultLoading.vue";
import DiamondsSearchResultEmpty from "./result/diamondsSearchResultEmpty.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondsSearchResult',
  props: {
    activeFilters: {}
  },
  setup(__props: any) {

const props = __props;


const diamonds = ref<any[]>([]);
const currentPage = ref(1);
const lastPage = ref(1);
const totalDiamonds = ref(0);
const isLoading = ref(false);
const isAppending = ref(false);
let controller: AbortController | null = null;

const fetchDiamonds = async (append = false) => {
  if (controller) {
    controller.abort();
  }
  controller = new AbortController();
  const signal = controller.signal;

  if (!append) {
    currentPage.value = 1;
    // We don't clear diamonds immediately here to avoid layout jump if it's very fast,
    // but the issue says "If the filter change the current diamonds should be removed"
    diamonds.value = [];
  }
  isLoading.value = true;
  isAppending.value = append;

  try {
    const requestBody: any = {
      type: props.activeFilters.type || "earth",
      size: {
        from: props.activeFilters.size?.min || 0,
        till: props.activeFilters.size?.max >= 10 ? 1000: props.activeFilters.size?.max || 0,
      },
      form: props.activeFilters.form ? [props.activeFilters.form] : [],
      color: props.activeFilters.color ? props.activeFilters.color : [],
      clarity: props.activeFilters.clarity ? props.activeFilters.clarity : [],
      cut: props.activeFilters.cut ? props.activeFilters.cut : [],
      polish: props.activeFilters.polish ? props.activeFilters.polish : [],
      symmetry: props.activeFilters.symmetry ? props.activeFilters.symmetry : [],
      fluorescence: props.activeFilters.fluorescence ? props.activeFilters.fluorescence : [],
      price: {
        from: props.activeFilters.price?.min || 0,
        till: props.activeFilters.price?.max || 0,
      },
      institute: props.activeFilters.institute ? props.activeFilters.institute : [],
      fastDelivery: props.activeFilters.fastDelivery || false,
      page: {
        current: currentPage.value,
        results: 16,
      },
      order: {
        by: "price",
        sort: props.activeFilters.sortOrder || "asc",
      },
      colored: props.activeFilters.colored || false,
      fancy_intensity: props.activeFilters.colored && props.activeFilters.fancy_intensity ? props.activeFilters.fancy_intensity : [],
    };

    const response = await fetch(`${process.env.VUE_APP_DIAMOND_API}/search`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
      signal,
    });

    if (response.ok) {
      const data = await response.json();
      if (append) {
        diamonds.value = [...diamonds.value, ...data.diamonds];
      } else {
        diamonds.value = data.diamonds;
      }
      lastPage.value = data.page.last;
      totalDiamonds.value = data.page.all;
    }
  } catch (error: any) {
    if (error.name === "AbortError") return;
    console.error("Error fetching diamonds:", error);
  } finally {
    if (!signal.aborted) {
      isLoading.value = false;
      isAppending.value = false;
    }
  }
};

watch(
  () => props.activeFilters,
  () => {
    currentPage.value = 1;
    fetchDiamonds();
  },
  { deep: true }
);

const loadMore = () => {
  if (currentPage.value < lastPage.value) {
    currentPage.value++;
    fetchDiamonds(true);
  }
};

onMounted(() => {
  fetchDiamonds();
});

onUnmounted(() => {
  if (controller) {
    controller.abort();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (diamonds.value.length > 0 || isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(diamonds.value, (diamond) => {
            return (_openBlock(), _createBlock(DiamondsSearchResultDiamond, {
              key: diamond.link,
              diamond: diamond
            }, null, 8, ["diamond"]))
          }), 128)),
          (isLoading.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((isAppending.value ? 3 : 12), (i) => {
                return (_openBlock(), _createBlock(DiamondsSearchResultLoading, { key: i }))
              }), 128))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(DiamondsSearchResultEmpty, { key: 1 })),
    (currentPage.value < lastPage.value && !isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: loadMore,
            class: "bg-[#B0A695] text-white px-8 py-3 uppercase tracking-[0.2em] text-sm hover:bg-[#9F9584] transition-colors"
          }, " Weitere laden ")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})